"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInputContainer = exports.WarningMessage = exports.SelectWrapper = exports.StyledInput = exports.TimesIconWrapper = exports.SearchIconWrapper = exports.ButtonGroup = exports.StyledBody = exports.StyledFlex = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Message = _interopRequireDefault(require("../Message"));

var _focusRingWithColor = _interopRequireDefault(require("../../utils/focusRingWithColor"));

var _Input = _interopRequireDefault(require("../TextField/Input"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var StyledFlex = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "styles__StyledFlex",
  componentId: "rlmiu8-0"
})(["align-items:center;[cursor='text']{height:", "px;> div{", ";padding-bottom:", ";}}"], function (_ref) {
  var mediumSized = _ref.mediumSized;
  return mediumSized ? 50 : 32;
}, function (_ref2) {
  var mediumSized = _ref2.mediumSized;
  return !mediumSized && "padding-top: ".concat((0, _rem.default)(_spacing.default.base * 0.1));
}, function (_ref3) {
  var mediumSized = _ref3.mediumSized;
  return (0, _rem.default)(_spacing.default.base * (mediumSized ? 0.6 : 0.1));
});
exports.StyledFlex = StyledFlex;
var StyledBody = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "styles__StyledBody",
  componentId: "rlmiu8-1"
})(["flex:1;align-items:center;height:inherit;"]);
exports.StyledBody = StyledBody;
var ButtonGroup = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "styles__ButtonGroup",
  componentId: "rlmiu8-2"
})(["align-items:center;margin-right:", ";cursor:default;"], function (_ref4) {
  var mediumSized = _ref4.mediumSized;
  return (0, _rem.default)(_spacing.default.base * (mediumSized ? 1 : 0.3));
});
exports.ButtonGroup = ButtonGroup;
var SearchIconWrapper = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "styles__SearchIconWrapper",
  componentId: "rlmiu8-3"
})(["color:", ";margin-right:", ";margin-left:", ";align-items:center;"], (0, _toColorString.default)(_color.default.base.alaskanHusky), (0, _rem.default)(_spacing.default.base * 1.5), function (_ref5) {
  var inputSize = _ref5.inputSize;
  return inputSize === 'small' ? 0 : (0, _rem.default)(_spacing.default.base * 0.5);
});
exports.SearchIconWrapper = SearchIconWrapper;
var TimesIconWrapper = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "styles__TimesIconWrapper",
  componentId: "rlmiu8-4"
})(["height:inherit;visibility:", ";margin-right:", ";color:", ";align-items:center;border:1px solid transparent;border-radius:2px;&:hover{color:", ";}&:focus{outline:none;border:1px solid ", ";", "}"], function (_ref6) {
  var visible = _ref6.visible;
  return visible ? 'visible' : 'hidden';
}, (0, _rem.default)(_spacing.default.base), (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _toColorString.default)(_color.default.status.danger.medium), (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _focusRingWithColor.default)(_color.default.interaction.pacificOcean40));
exports.TimesIconWrapper = TimesIconWrapper;
var StyledInput = (0, _styledComponents.default)(_Input.default).withConfig({
  displayName: "styles__StyledInput",
  componentId: "rlmiu8-5"
})(["padding:0;color:", ";"], (0, _toColorString.default)(_color.default.base.charcoal));
exports.StyledInput = StyledInput;
var SelectWrapper = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "styles__SelectWrapper",
  componentId: "rlmiu8-6"
})(["margin-right:-1px;", " &:hover,&:active,&:focus-within{z-index:100;}"], function (_ref7) {
  var width = _ref7.width;
  return width && (0, _styledComponents.css)(["max-width:", ";min-width:", ";"], width, width);
});
exports.SelectWrapper = SelectWrapper;
var WarningMessage = (0, _styledComponents.default)(_Message.default).withConfig({
  displayName: "styles__WarningMessage",
  componentId: "rlmiu8-7"
})([""]);
exports.WarningMessage = WarningMessage;
var SearchInputContainer = (0, _styledComponents.default)(_Flex.default).attrs({
  flexDirection: 'column'
}).withConfig({
  displayName: "styles__SearchInputContainer",
  componentId: "rlmiu8-8"
})(["gap:", ";flex:1;"], (0, _rem.default)(_spacing.default.base * 0.5));
exports.SearchInputContainer = SearchInputContainer;